import { useLayoutEffect } from 'react';

const myObserver = new ResizeObserver((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
  for (const entry of entries) {
    const obsElem = findActiveObservedElement(entry.target);
    if (obsElem) obsElem.callback(entry);
  }
});

let activeObservedElements: any[] = [];

function addActiveObservedElement(element: any, callback: any) {
  activeObservedElements.push({
    element: element,
    callback: callback,
  });
}

function delActiveObservedElement(element: any) {
  activeObservedElements = activeObservedElements.filter(function (e) {
    return e.element !== element;
  });
}

function findActiveObservedElement(element: any) {
  for (const obsElem of activeObservedElements) if (obsElem.element == element) return obsElem;
  return null;
}

const useResizeObserver = (ref: any, callback: any) => {
  useLayoutEffect(() => {
    if (ref.current) {
      myObserver.observe(ref.current);
      addActiveObservedElement(ref.current, callback);
    }
    // Terminator callback
    return () => {
      if (myObserver && ref && ref.current) myObserver.unobserve(ref.current);
      delActiveObservedElement(ref.current);
    };
  }, [ref.current]);
};

export default useResizeObserver;
